// import { canUseDOM } from 'exenv';

export function innovationByDesignAllFeedLoading(resp = {}, store = {}) {
  return {
    type: 'INNOVATION_BY_DESIGN_ALL_FEED_LOADING',
    innovationByDesignAllFeed: resp,
    store
  };
}

export function innovationByDesignAllFeedLoaded(resp = {}, store = {}) {
  return {
    type: 'INNOVATION_BY_DESIGN_ALL_FEED_LOADED',
    innovationByDesignAllFeed: resp,
    store
  };
}

export function innovationByDesignAllFeedLoadError(error, store = {}) {
  return {
    type: 'INNOVATION_BY_DESIGN_ALL_FEED_ERROR',
    innovationByDesignAllFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}

export function innovationByDesignAllFeedAllStoriesRendered() {
  return {
    type: 'INNOVATION_BY_DESIGN_ALL_FEED_ALL_STORIES_RENDERED',
    allRendered: true
  };
}
